export enum EcommerceEvent {
  Purchase = 'purchase',
  AddToCart = 'addToCart',
  RemoveFromCart = 'removeFromCart',
  Checkout = 'checkout',
  CheckoutOption = 'checkoutOption',
}
